(function () {
  'use strict';
  if (typeof window === 'undefined') return;
  window.SofmatGuide = function (options) {
    var dialog = null, index = 0, marked = null, before = null;
    var key = 'sofmat-guide-v1:' + options.scope + ':' + options.user + ':' + options.company;
    function seen() { try { return localStorage.getItem(key) === 'done'; } catch (_) { return false; } }
    function remember() { try { localStorage.setItem(key, 'done'); } catch (_) {} }
    function unmark() { if (marked) marked.classList.remove('sf-guide-target'); marked = null; }
    function close(save) {
      if (save) remember();
      unmark();
      if (dialog) { dialog.remove(); dialog = null; }
      if (before && before.isConnected) before.focus({ preventScroll: true });
      before = null;
      window.removeEventListener('resize', position);
    }
    function position() {
      if (!dialog) return;
      var width = Math.min(370, window.innerWidth - 32), top = Math.max(16,(window.innerHeight - dialog.offsetHeight)/2), left = Math.max(16,(window.innerWidth-width)/2);
      if (marked && marked.getBoundingClientRect().width > 0 && window.innerWidth > 700) {
        var r = marked.getBoundingClientRect();
        left = Math.max(16,Math.min(window.innerWidth-width-16,r.right+16));
        if (left < r.right) left = Math.max(16,r.left-width-16);
        top = Math.max(16,Math.min(window.innerHeight-dialog.offsetHeight-16,r.top));
      }
      dialog.style.width = width+'px'; dialog.style.left=left+'px'; dialog.style.top=top+'px';
    }
    function button(label, action, primary) {
      var b=document.createElement('button'); b.type='button';b.textContent=label;b.className=primary?'sf-guide-primary':'sf-guide-secondary';b.addEventListener('click',action);return b;
    }
    function draw() {
      if (!dialog) return;
      unmark(); dialog.replaceChildren();
      var steps=options.steps(), step=steps[index];
      if (!step) { close(true); return; }
      if (step.target) {
        marked=Array.from(document.querySelectorAll(step.target)).find(function(el){return el.getBoundingClientRect().width>0;}) || null;
        if (marked) { marked.classList.add('sf-guide-target'); marked.scrollIntoView({block:'nearest',inline:'nearest',behavior:'auto'}); }
      }
      var count=document.createElement('p');count.className='sf-guide-counter';count.textContent='GUIDA SOFMAT · '+(index+1)+' / '+steps.length;
      var title=document.createElement('h2');title.id='sf-guide-title';title.textContent=step.title;
      var body=document.createElement('p');body.id='sf-guide-body';body.textContent=step.text;
      var actions=document.createElement('div');actions.className='sf-guide-actions';
      actions.append(button('Chiudi guida',function(){close(true);},false));
      if(index>0)actions.append(button('Indietro',function(){index--;draw();},false));
      actions.append(button(index===steps.length-1?'Ho capito':'Avanti',function(){index++;draw();},true));
      dialog.append(count,title,body,actions);position();
      actions.lastElementChild.focus();
    }
    function start() {
      if(dialog)return;
      before=document.activeElement;index=0;
      dialog=document.createElement('dialog');dialog.className='sf-guide-dialog';dialog.setAttribute('aria-labelledby','sf-guide-title');dialog.setAttribute('aria-describedby','sf-guide-body');
      dialog.addEventListener('cancel',function(e){e.preventDefault();close(true);});
      document.body.append(dialog);
      if(typeof dialog.showModal!=='function'){dialog.remove();dialog=null;return;}
      dialog.showModal();draw();window.addEventListener('resize',position);
    }
    var trigger=options.trigger;
    if(trigger)trigger.addEventListener('click',start);
    var timer=null;
    if(options.auto && !seen()) timer=window.setTimeout(function(){
      if (!document.querySelector('dialog[open]') && !/^(INPUT|TEXTAREA|SELECT)$/.test(document.activeElement.tagName)) start();
    },800);
    return { start:start, destroy:function(){if(timer)clearTimeout(timer);close(false);if(trigger)trigger.removeEventListener('click',start);} };
  };
  document.addEventListener('DOMContentLoaded',function(){
    var trigger=document.querySelector('[data-sf-guide-open]');if(!trigger)return;
    window.SofmatGuide({scope:'portal',user:trigger.dataset.user,company:trigger.dataset.company,trigger:trigger,auto:true,steps:function(){return [
      {title:'Il tuo spazio aziendale',text:'Qui gestisci la tua azienda. Il nome nell’intestazione indica sempre lo spazio in cui stai lavorando.',target:'.sf-account-switch'},
      {title:'Parti da QuoteOS',text:'Dal menu degli spazi scegli QuoteOS per caricare un disegno e preparare un preventivo. Entri con lo stesso account SOFMAT.',target:'.sf-space-switch'},
      {title:'Gli strumenti della rete',text:'Workshop raccoglie community e richieste di lavorazione; SupplyHub i fornitori; Academy i corsi disponibili. I dati restano visibili secondo i tuoi permessi.',target:'.sf-space-switch'},
      {title:'Piano e membri del team',text:'Dal menu della tua azienda controlli l’abbonamento e, se sei titolare, inviti i collaboratori entro il limite del pacchetto.',target:'.sf-account-switch'},
      {title:'Assistenza sempre disponibile',text:'Apri Assistenza per inviare un ticket. Puoi riaprire questa spiegazione quando vuoi con il pulsante Guida iniziale.',target:'[data-sf-guide-open]'}
    ];}});
  });
})();
